import cn from 'classnames';
import React, {useState} from 'react';
import MaskedInput from 'react-text-mask';

import {AppButton} from '../../../components/Button';
import ConnectionTrackButton from '../../../components/Button/ConnectionTrackButton/ConnectionTrackButton';
import {ErrorIcon} from '../../../components/Icons';
import SkipRegistrationButton from '../../../components/SkipRegistrationButton/SkipRegistrationButton';
import useIsShowSkipRegistrationButton from '../../../hooks/useIsShowSkipRegistrationButton';
import modalService from '../../../services/modalService';
import {getButtonText, getInputErrorText} from './registrationManualService';
import useManualRegistrationSubmit from './useManualRegistrationSubmit';

// prettier-ignore
const INPUT_MASK = [/\w/, /\w/, /\w/, /\w/, ' ', /\w/, /\w/, /\w/, ' ', /\w/, /\w/, /\w/, ' ', /\w/, /\w/, /\w/, /\w/];

const ManualRegistrationForm = ({
    pageContent,
    productName,
    modalType,
    manualRegistrationError,
    codentifyWithError,
    isHolder,
}) => {
    const [codentify, setCodentify] = useState(codentifyWithError);
    const [registrationError, setRegistrationError] = useState(manualRegistrationError);
    const inputErrorText = getInputErrorText(registrationError, productName);
    const {inputLabel, placeholder} = pageContent;
    const buttonText = getButtonText(registrationError);

    const isShowSkipReg = useIsShowSkipRegistrationButton();

    const onChange = (event) => {
        const {value} = event.target;
        const inputValue = value.replace(/ /g, '').toUpperCase();

        setCodentify(inputValue);
    };

    const {onSubmit} = useManualRegistrationSubmit({
        registrationError,
        codentify,
        setRegistrationError,
        modalType,
        isHolder,
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit();
    };

    return (
        <form onSubmit={handleSubmit} className='flex w-full flex-col items-center md:max-w-[312px] md:items-start '>
            <div className='mb-4 mt-6 self-start text-14 leading-14 tracking-04'>{inputLabel}</div>
            <div className='relative w-full'>
                <MaskedInput
                    guide={false}
                    value={codentify}
                    mask={INPUT_MASK}
                    onChange={onChange}
                    placeholder={placeholder}
                    className={cn(
                        'h-12 w-full rounded-[3px] border border-solid border-border bg-romance px-[18px] py-3 text-start',
                        {'border-2 border-error': registrationError}
                    )}
                />
                {registrationError && (
                    <ErrorIcon className='absolute right-3 top-1/2 z-10 h-6 w-6 -translate-y-1/2 rtl:left-3 rtl:right-auto md:rtl:right-auto' />
                )}
            </div>
            {registrationError && (
                <div className='mt-1 text-start text-12 tracking-04 text-error'>{inputErrorText}</div>
            )}
            <ConnectionTrackButton primary light className='mt-8 w-full' key={buttonText} button={AppButton}>
                {buttonText}
            </ConnectionTrackButton>
            {isShowSkipReg && <SkipRegistrationButton onSkipClick={() => modalService.hideModal(modalType)} />}
        </form>
    );
};

export default ManualRegistrationForm;
